import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap-5';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type FooterProps = {
  children?: React.ReactNode;
  footerOrientation?: 'left' | 'right' | 'center';
};

type ModalProps = {
  children?: React.ReactNode;
  className?: string;
  icon?: FontAwesomeIconProps['icon'];
  show: boolean;
  size?: 'sm' | 'lg' | 'xl';
  title: string;
  onHide: () => void;
}

function Modal({ children, className, icon, show, size, title, onHide }: ModalProps) {
  return (
    <BootstrapModal className={className} show={show} size={size} onHide={onHide}>
      <BootstrapModal.Header>
        <BootstrapModal.Title className="d-flex text-center gap-2 align-items-center">
          {icon && <FontAwesomeIcon className="text-primary" icon={icon} />}
          {title}
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body className="modal-padding overflow-auto">
        {children}
      </BootstrapModal.Body>
    </BootstrapModal>
  );
}

export function Footer({ children, footerOrientation }: FooterProps) {
  const footerOrientationClass = () => {
    switch (footerOrientation) {
    case 'center':
      return 'text-center';
    case 'left':
      return 'text-start';
    case 'right':
      return 'text-end';
    }
  };

  return (
    <div className={`${footerOrientationClass()} mt-5`}>
      {children}
    </div>
  );
}

Modal.Footer = Footer;
export default Modal;
